export enum QueryTag {
  CurrentUser = 'CurrentUser',
  Rule = 'Rule',
  CommunityRule = 'CommunityRule',
  MCP = 'MCP',
}
